<template>
  <div class="container-bg-white mt-3">
    <slot name="summary_top"></slot>
    <div class="row p-3">
      <div class="col-12 mb-2 mb-1">
        <img src="@/assets/images/filter.svg"/>
        <span class="ml-3">
            {{$t("flexben.voucher_stocks.invoicesFields.voucherWithoutInvoiceFilter")}}
            <font-awesome-icon
              icon="info-circle"
              class="ml-1 cursor-pointer"
              v-b-tooltip.hover.topleft
              :title="$t('flexben.voucher_stocks.invoicesFields.tooltips.voucherWithoutInvoiceInfo')"
            />
        </span>

      </div>
      <div class="col-12 col-md-6 form-group mb-0">
        <label class="col-form-label" for="voucher_purchase_start_date">
          {{$t("flexben.voucher_stocks.inputLabels.startDate")}}
        </label>
        <div class="w-100 d-inline-flex">
          <label for="voucher_purchase_start_date" class="my-2 mr-2">
            <font-awesome-icon icon="calendar-alt" class="text-24"/>
          </label>
          <vue-datepicker
            :format="dateFormat"
            :inputClass="'form-control-d m-0 w-100 background-white'"
            :disabled-dates="disabledDatesConfig"
            v-model="voucherFilters.purchaseVoucherDateFrom"
            :class="'w-100'"
            @input="updateFilter('purchaseVoucherDateFrom')"
            @cleared="clearFilter('purchaseVoucherDateFrom')"
            id="voucher_purchase_start_date">
          </vue-datepicker>
          <img class="cursor-pointer ml-2" alt="x"
               src="@/assets/images/flexben/table-remove-button.svg"
               @click="clearFilter('purchaseVoucherDateFrom')"/>
        </div>
        <small v-if="startDateError" class="text-danger">
          {{$t("flexben.voucher_stocks.invoicesFields.errors.startDateRequired")}}
        </small>

      </div>
      <div class="col-12 col-md-6 form-group mb-0">
        <label class="col-form-label" for="voucher_purchase_end_date">
          {{$t("flexben.voucher_stocks.inputLabels.endDate")}}
        </label>
        <div class="w-100 d-inline-flex">
          <label for="voucher_purchase_end_date" class="my-2 mr-2">
            <font-awesome-icon icon="calendar-alt" class="text-24"/>
          </label>
          <vue-datepicker
            :format="dateFormat"
            :inputClass="'form-control-d m-0 w-100 background-white'"
            v-model="voucherFilters.purchaseVoucherDateTo"
            :class="'w-100'"
            @input="updateFilter('purchaseVoucherDateTo')"
            @cleared="clearFilter('purchaseVoucherDateTo')"
            id="voucher_purchase_end_date">
          </vue-datepicker>
          <img class="cursor-pointer ml-2" alt="x"
               src="@/assets/images/flexben/table-remove-button.svg"
               @click="clearFilter('purchaseVoucherDateTo')"/>
        </div>
      </div>
      <div class="col-12 text-center mt-3">
        <button class="btn btn-themed px-4"
                :disabled="!canDownload"
                @click="downloadVouchersReport">
          {{$t("flexben.general.btn.export")}}
        </button>
      </div>
    </div>
    <slot name="summary_bottom"></slot>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  name: "VoucherWithoutInvoicesFilters",
  components: {
    'vue-datepicker': Datepicker,
  },
  data() {
    return {
      dateFormat: 'dd/MM/yyyy',
      voucherFilters: {
        purchaseVoucherDateFrom: null,
        purchaseVoucherDateTo: null,
      },startDateError: false,
    };
  },
  computed: {
    canDownload() {
      return this.voucherFilters.purchaseVoucherDateFrom;
    },
    disabledDatesConfig() {
      const oneYearAgo = moment().subtract(1, 'year').toDate();
      return {
        to: oneYearAgo,
      };
    }
  },
  methods: {
    updateFilter(filterKey) {
      if (filterKey === 'purchaseVoucherDateFrom') {
        this.startDateError = false;
      }
      this.$emit('voucherFilterChanged', {
        key: filterKey,
        value: moment(this.voucherFilters[filterKey]).format('YYYY-MM-DD'),
        allFilters: this.formatFiltersForAPI()
      });
    },

    clearFilter(filterKey) {
      this.voucherFilters[filterKey] = null;
      this.$emit('voucherFilterChanged', {
        key: filterKey,
        value: null,
        allFilters: this.formatFiltersForAPI()
      });
    },

    formatFiltersForAPI() {
      return {
        purchaseVoucherDateFrom: this.voucherFilters.purchaseVoucherDateFrom ?
          moment(this.voucherFilters.purchaseVoucherDateFrom).format('YYYY-MM-DD') : null,
        purchaseVoucherDateTo: this.voucherFilters.purchaseVoucherDateTo ?
          moment(this.voucherFilters.purchaseVoucherDateTo).format('YYYY-MM-DD') : null,
      };
    },

    downloadVouchersReport() {
      if (!this.canDownload) {
        return;
      }
      if (!this.voucherFilters.purchaseVoucherDateFrom) {
        this.startDateError = true;
        return;
      }
      this.$emit('downloadVouchersWithoutInvoices', this.formatFiltersForAPI());
    }
  }
}
</script>
